import * as React from "react";
import { forwardRef } from "react";
import { jsx as _jsx } from "react/jsx-runtime";
const SvgUserTwo = (props, ref) => /* @__PURE__ */ _jsx("svg", {
	width: 16,
	height: 16,
	viewBox: "0 0 16 16",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	ref,
	...props,
	children: /* @__PURE__ */ _jsx("path", {
		d: "M11.333 2.35677C12.1301 2.81785 12.6664 3.67964 12.6664 4.66669C12.6664 5.65374 12.1301 6.51554 11.333 6.97662M13.9997 13.8216C14.3982 13.5911 14.6663 13.1602 14.6663 12.6667C14.6663 11.6796 14.1301 10.8179 13.333 10.3568M9.33301 4.66667C9.33301 6.13943 8.1391 7.33333 6.66634 7.33333C5.19358 7.33333 3.99967 6.13943 3.99967 4.66667C3.99967 3.19391 5.19358 2 6.66634 2C8.1391 2 9.33301 3.19391 9.33301 4.66667ZM3.99967 10H9.33301C10.8058 10 11.9997 11.1939 11.9997 12.6667C11.9997 13.403 11.4027 14 10.6663 14H2.66634C1.92996 14 1.33301 13.403 1.33301 12.6667C1.33301 11.1939 2.52692 10 3.99967 10Z",
		stroke: "#111827",
		strokeWidth: 1.5,
		strokeLinecap: "round",
		strokeLinejoin: "round"
	})
});
const ForwardRef = forwardRef(SvgUserTwo);
export default ForwardRef;
